import React, { useState } from 'react';
import { Input, Button, Modal, Spin, Checkbox } from 'antd';
import {
  StepBackwardOutlined, CaretLeftOutlined,
  CaretRightOutlined, StepForwardOutlined,
  PlusOutlined, EditOutlined, DeleteOutlined,
  SaveOutlined, CloseOutlined, SearchOutlined,
} from '@ant-design/icons';
import { useColorCodeForm } from './hooks/useColorCodeForm';
import './P1114Form.css';

const { TextArea } = Input;

const P1114Form: React.FC = () => {
  const {
    mode, loading,
    f114_01, f114_02, f114_11, f114_12, f114_14, f114_15,
    f114_91, f114_92, f114_93,
    setF11401, setF11411, setF11412, setF11414, setF11415,
    navFirst, navPrev, navNext, navLast,
    startAdd, startEdit, cancel, save, doDelete,
    quickSearch, recordPosition, recordCount,
  } = useColorCodeForm();

  const [searchKey, setSearchKey] = useState('');

  const isEditing = mode === 'add' || mode === 'edit';

  return (
    <Spin spinning={loading}>
      <div className="p1114-form">
        <h2>色號定義</h2>

        {/* Quick Search */}
        <div className="p1114-search-bar">
          <Input
            placeholder="輸入色號快速搜尋"
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value)}
            onPressEnter={() => quickSearch(searchKey)}
            style={{ width: 200 }}
            disabled={isEditing}
          />
          <Button
            icon={<SearchOutlined />}
            onClick={() => quickSearch(searchKey)}
            disabled={isEditing}
          >
            搜尋
          </Button>
          <span className="p1114-record-info">
            {recordPosition} / {recordCount}
          </span>
        </div>

        {/* Navigation */}
        <div className="p1114-nav-bar">
          <Button icon={<StepBackwardOutlined />} onClick={navFirst} disabled={isEditing}>首筆</Button>
          <Button icon={<CaretLeftOutlined />} onClick={navPrev} disabled={isEditing}>前筆</Button>
          <Button icon={<CaretRightOutlined />} onClick={navNext} disabled={isEditing}>次筆</Button>
          <Button icon={<StepForwardOutlined />} onClick={navLast} disabled={isEditing}>末筆</Button>
        </div>

        {/* Form Fields */}
        <div className="p1114-fields">
          <div className="p1114-field-row">
            <label>色號代碼</label>
            <Input
              value={f114_01}
              onChange={(e) => setF11401(e.target.value.toUpperCase())}
              maxLength={3}
              disabled={mode !== 'add'}
              style={{ width: 100 }}
            />
          </div>
          <div className="p1114-field-row">
            <label>舊代號</label>
            <Input
              value={f114_02}
              maxLength={6}
              disabled
              style={{ width: 120 }}
            />
          </div>
          <div className="p1114-field-row">
            <label>中文色名</label>
            <Input
              value={f114_11}
              onChange={(e) => setF11411(e.target.value)}
              maxLength={50}
              disabled={!isEditing}
              style={{ width: 300 }}
            />
          </div>
          <div className="p1114-field-row">
            <label>英文色名</label>
            <Input
              value={f114_12}
              onChange={(e) => setF11412(e.target.value)}
              maxLength={50}
              disabled={!isEditing}
              style={{ width: 300 }}
            />
          </div>
          <div className="p1114-field-row">
            <label>舊代號標記</label>
            <Checkbox
              checked={f114_14}
              onChange={(e) => setF11414(e.target.checked)}
              disabled={!isEditing}
            >
              此為舊代號
            </Checkbox>
          </div>
          <div className="p1114-field-row">
            <label>備註</label>
            <TextArea
              value={f114_15}
              onChange={(e) => setF11415(e.target.value)}
              disabled={!isEditing}
              rows={3}
              style={{ width: 300 }}
            />
          </div>

          {/* Audit fields (read-only) */}
          <div className="p1114-field-row">
            <label>建立人員</label>
            <Input value={f114_91} disabled style={{ width: 120 }} />
          </div>
          <div className="p1114-field-row">
            <label>建立日期</label>
            <Input value={f114_92 ? f114_92.substring(0, 10) : ''} disabled style={{ width: 140 }} />
          </div>
          <div className="p1114-field-row">
            <label>異動人員</label>
            <Input value={f114_93} disabled style={{ width: 120 }} />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="p1114-actions">
          {!isEditing ? (
            <>
              <Button type="primary" icon={<PlusOutlined />} onClick={startAdd}>新增</Button>
              <Button icon={<EditOutlined />} onClick={startEdit} disabled={recordCount === 0}>修改</Button>
              <Button
                danger
                icon={<DeleteOutlined />}
                disabled={recordCount === 0}
                onClick={() => {
                  Modal.confirm({
                    title: '確認刪除',
                    content: `確定要刪除色號 ${f114_01} 嗎？`,
                    onOk: doDelete,
                  });
                }}
              >
                刪除
              </Button>
            </>
          ) : (
            <>
              <Button type="primary" icon={<SaveOutlined />} onClick={save}>存檔</Button>
              <Button icon={<CloseOutlined />} onClick={cancel}>還原</Button>
            </>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default P1114Form;
